<nz-skeleton [nzParagraph]="{ rows: 10 }" [nzLoading]="(isWorklistLoading$ | async) ?? false">
  <ng-container *ngIf="error$ | async as errorMsg; else result">
    <em-error-result [subTitle]="errorMsg"></em-error-result>
  </ng-container>
</nz-skeleton>

<ng-template #result>
  <ng-container *ngIf="worklistItems$ | async as worklistItems">
    <nz-table #worklistTable [nzData]="worklistItems" nzSize="small">
      <thead>
        <tr>
          <th>Id</th>
          <th>Description</th>
          <th>Designer</th>
          <th>Make/buy</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of worklistTable.data; trackBy: trackByRef">
          <td>
            <a [routerLink]="'/data/design/' + item.designId">{{ item.designId }}</a>
          </td>
          <td>
            {{ item.designDescription }}
          </td>
          <td>{{ item.designerName }} ({{ item.designer }})</td>
          <td>
            {{ item.makeBuy }}
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</ng-template>
